import type { ModalProps, PopconfirmProps } from 'antd';
import classNames from 'classnames';
import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Button, Popconfirm } from 'ui/base/index';

type FooterProps = {
  confirm?: Partial<PopconfirmProps>;
} & Pick<ModalProps, 'okButtonProps' | 'cancelButtonProps' | 'onOk' | 'onCancel' | 'cancelText' | 'className'>;

const Footer: React.FC<FooterProps> = ({ onOk, onCancel, className, okButtonProps, cancelButtonProps, confirm }) => {
  const onCancelButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!confirm && onCancel) {
      onCancel(e);
    }
  };

  return (
    <div
      className={classNames(className, 'd-flex justify-content-between w-100')}
    >
      <Popconfirm {...confirm} title={confirm?.title ?? ''}>
        <Button onClick={onCancelButton} {...cancelButtonProps}>
          <FormattedMessage id="cancel" defaultMessage="Cancel" />
        </Button>
      </Popconfirm>
      <Button type="primary" onClick={onOk} {...okButtonProps}>
        <FormattedMessage id="save" defaultMessage="Save" />
      </Button>
    </div>
  );
};

export default Footer;
